/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type ToDoSortKey = typeof ToDoSortKey[keyof typeof ToDoSortKey];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ToDoSortKey = {
  Default: 'Default',
  DueDate: 'DueDate',
  Urgent: 'Urgent',
} as const;
